export default __webpack_public_path__ + "media/images/dogs-car-a3e283cbcbc96dca4b082bf4b159c818.png";